import { registerSW as register } from 'virtual:pwa-register';
import { processQueue } from './services/syncService';

/** How often to ask the browser to check for a new service worker. */
const UPDATE_CHECK_MS = 2 * 60 * 1000; // 2 minutes

/**
 * Register the PWA service worker and auto-apply updates after deploy.
 * Users should not need a hard refresh on Chrome, Edge, or Safari.
 */
export function registerSW() {
  let registration = null;

  const updateSW = register({
    immediate: true,
    onNeedRefresh() {
      // New SW waiting — activate and reload (no confirm; Cancel left users on old UI).
      updateSW(true);
    },
    onOfflineReady() {
      console.log('[SW] App ready to work offline');
    },
    onRegisteredSW(_swUrl, reg) {
      registration = reg || null;
      console.log('[SW] Service Worker registered:', registration);
      if (!registration) return;

      if ('sync' in registration) {
        console.log('[SW] Background Sync API supported');
      }

      const checkForUpdate = () => {
        registration?.update().catch((err) => {
          console.warn('[SW] Update check failed:', err);
        });
      };

      setInterval(checkForUpdate, UPDATE_CHECK_MS);

      // Check when user returns to the tab (covers Safari background throttling).
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdate();
      });
      window.addEventListener('focus', checkForUpdate);
    },
    onRegisterError(error) {
      console.error('[SW] Service Worker registration error:', error);
    }
  });

  // Reload once when the new SW takes control (covers autoUpdate + skipWaiting).
  if ('serviceWorker' in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SYNC_REQUESTED') {
        console.log('[SW] Background sync triggered, processing queue...');
        processQueue().catch((err) =>
          console.error('[SW] Error processing sync queue from background sync:', err)
        );
      }
    });
  }
}
